import React from 'react'
import CommonImage from "@/components/common/image/CommonImage";
import { useSelector } from 'react-redux';

export default function GamificationSection() {
    const setting = useSelector((state) => state.setting.data);

  return (
    <section className="gamification_section section_padding bg-white">
      <div className="container">
        <div className="grid grid-cols-12 md:gap-6 gap-4 items-center">

          <div className="lg:col-span-5 col-span-12">
            <div className="image-part">
              <CommonImage src={setting?.gamification_image_url ?? "/images/home-page/gamifiction.avif"} className="gamification-thumbnail leading-0" alt={'Image'} />
            </div>
          </div>

          <div className="lg:col-span-7 col-span-12">
            <div className="details-part">
            <h2 className="main-title">
              <span className="text-light">{
                setting?.gamification_title?.split('সাথে')[0] + 'সাথে'
              }</span> {
                setting?.gamification_title?.split('সাথে')[1]
              }
            </h2>
              <p className="short-des" dangerouslySetInnerHTML={{ __html: setting?.gamification_description || '' }} />

            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
